const apiBase = () => (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) || '';

const authHeaders = (userId: string, orgId?: string): Record<string, string> => ({
  'Content-Type': 'application/json',
  'x-api-key': 'revisr',
  'x-user-id': userId,
  ...(orgId ? { 'x-org-id': orgId } : {}),
});

export type UserActivity = {
  userId: string;
  userName: string | null;
  email: string | null;
  policyCount: number;
  lastPolicyAt: string | null;
};

export type OrganisationActivity = {
  orgId: string;
  orgName: string | null;
  policyCount: number;
  lastPolicyAt: string | null;
  users: UserActivity[];
};

export type ActivityTotals = {
  totalPolicies: number;
  totalOrganisations: number;
  totalUsers: number;
};

export const fetchActivityLog = async (
  userId: string,
  orgId?: string,
): Promise<{ organisations: OrganisationActivity[]; totals: ActivityTotals }> => {
  const res = await fetch(`${apiBase()}/api/revisr/activity-log/admin`, {
    headers: authHeaders(userId, orgId),
  });
  if (!res.ok) throw new Error(`Failed to load activity log: ${res.status}`);
  return res.json();
};
